<template>
    <div class="cms-view">
        <template v-if="['/',`/${$i18n.locale.split('-')[0]}`].includes($route.path)">
            <transition name="fade" mode="out-in">
                <UploadHero
                    v-if="
                        [
                            orderProcess.STEPS.NO_ORDER_ONGOING,
                            orderProcess.STEPS.ORDER_COMPLETED,
                        ].includes(currentOrderProcessStep) &&
                            [
                                viewports.DESKTOP.name,
                                viewports.WIDESCREEN.name,
                                viewports.FULL_HD.name,
                            ].includes(currentViewport)
                    "
                ></UploadHero>
                <CheckoutHero
                    v-else-if="
                        ![
                            viewports.MOBILE.name,
                            viewports.TABLET.name,
                        ].includes(currentViewport)
                    "
                ></CheckoutHero>
            </transition>
            <Steps
                v-if="
                    [
                        viewports.DESKTOP.name,
                        viewports.WIDESCREEN.name,
                        viewports.FULL_HD.name,
                    ].includes(currentViewport)
                "
            />
        </template>
        <transition name="fade">
            <div class="cms-view-content" v-if="pageContent"
                :class="{'is-subpage':!['/'].includes($route.path)}"
            >
                <CMSViewComponent
                    v-show="!isOrderProcessOngoing"
                    v-for="(element) in pageContent"
                    :key="'cms_content_element_' + element.id"
                    :element="element"
                />
            </div>
        </transition>
        <ContactForm v-if="$route.path === '/kontakt'" />
    </div>
</template>

<script>
import UploadHero from './layout/UploadHero';
import Steps from './layout/Steps';
import CMSViewComponent from './cms-content-types/CMSViewComponent';
import CheckoutHero from './checkout/CheckoutHero';
import { componentMapping } from '../store/constants/component-mapping';
import { orderProcess } from '../store/constants/order-process';
import { viewports } from '../store/constants/viewports';
import { mapGetters } from 'vuex';
import ContactForm from './Forms/ContactForm';

export default {
    name: 'CMSView',
    components: {
        ContactForm,
        CheckoutHero,
        CMSViewComponent,
        Steps,
        UploadHero,
    },
    data() {
        return {
            componentMapping,
            orderProcess,
            viewports,
        };
    },
    computed: {
        ...mapGetters(['currentOrderProcessStep', 'currentViewport']),
        cmsPage() {
            return this.$store.getters.cmsPage;
        },
        pageContent() {
            return this.cmsPage.content ? this.cmsPage.content.colPos0 : null;
        },
        isOrderProcessOngoing() {
            return (
                this.currentOrderProcessStep !==
                    orderProcess.STEPS.NO_ORDER_ONGOING &&
                this.currentOrderProcessStep !==
                    orderProcess.STEPS.ORDER_COMPLETED
            );
        },
    },
    methods: {
        fetchCMSData() {
            this.$store
                .dispatch('fetchCMSPage', { urlSlug: this.$route.path })
                .catch(() => {
                    this.$router.push('/not-available');
                });
        },
    },
    watch: {
        $route() {
            this.fetchCMSData();
        },
    },
    created() {
        this.fetchCMSData();
    },
};
</script>
